var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"once",on:{"~click":function($event){return _vm.onClickOnce.apply(null, arguments)}}},[_vm._v(" 只触发一次 ")])}
var staticRenderFns = []

export { render, staticRenderFns }